import { Inject, Component, ViewChild, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef } from "@angular/core";
import * as Immutable from 'immutable';
import { ConfInfo, VariableInfo, WarningVariablesMessage } from "../../../shared/models";
import { RegularPopupComponent } from "../../../../shared/components/popup";
import { PageActionCreator, PageStore } from "../../../shared/providers/page";
import { RouteRedirector, RouteNames } from "../../../shared/providers";
import { InputViewModel, ValueChangeEventArgs } from "../../../../shared/components/shared";
import { ConfPageSessionService, ConfiguratorStore, PopupIdentifiers, ConfRouteParams } from "../../providers";
import { AccordionComponent, PopupService } from "../../../../shared/components";
import { AbstractPopupComponent } from "../../../../shared/components/popup/abstractPopupComponent";

@Component({
    selector: 'warning-variables-popup',
    templateUrl: './warningVariablesPopupComponent.html'
})
export class WarningVariablesPopupComponent extends AbstractPopupComponent {

  public values: Array<WarningVariablesModel>;
 
  @ViewChild(AccordionComponent)
  accordionComponent: AccordionComponent;

  @Output()
  onClosed = new EventEmitter();

  constructor(
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,    
    @Inject(RouteRedirector) public routeRedirector: RouteRedirector,
    @Inject(PopupService) public popupService: PopupService,
    @Inject(PageStore) public pageStore: PageStore,
    public cdr: ChangeDetectorRef
  ) {
    super(cdr, popupService);
  }

  ngOnInit() {
    this.id = PopupIdentifiers.WarningVariables;
    super.ngOnInit();
  }

  public open(tag: any) {
    this.setup(tag);
    this.showInternal();    
  }

  setup(messages: Immutable.List<WarningVariablesMessage>): void {

    this.values = [];

    messages.forEach(message => {

      let warningVariableModel = new WarningVariablesModel();
      warningVariableModel.conf = this.confStore.getConfInfo(message.configurationId, this.storeSession.confSessionId);
      warningVariableModel.isActiveConf = this.storeSession.activeConfigurationId === message.configurationId;

      message.variableInfos.forEach((variableInfo: VariableInfo) => {
        let variableViewModel = new InputViewModel(variableInfo.title);
        variableViewModel.icon = "variable";
        variableViewModel.iconHeight = variableViewModel.iconWidth = "24px";
        variableViewModel.value = variableInfo.value;
        warningVariableModel.variableViewModels.push(variableViewModel);
      });

      this.values.push(warningVariableModel);

    });
  }

  public onPopupClosed() {
    this.values = null;
        
    super.onPopupClosed();
    this.onClosed.emit();
  }

  public onAccordionOpen(configurationId: number) {
    // Accordion expand will route to the clicked configuration 
    let params = <ConfRouteParams>{ id: configurationId, confSessionId: this.storeSession.confSessionId };
    if (this.pageStore.activeRouteName === RouteNames.Summary)
      this.routeRedirector.redirectToSummary(params);
    else
      this.routeRedirector.redirectToEditor(params)
  }

  public onAccordionToggle($event) {    
  }  
}

export class WarningVariablesModel {
  conf: ConfInfo;
  variableViewModels: Array<InputViewModel> = [];
  isActiveConf = false;
}